import _ from 'lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export default class CaptchaGenStatTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {string} */
        this.profileNames = null
		/** @type {string} */
        this.captchaTypeEngineName = null
		/** @type {string} */
        this.captchaTypeEngineParams = null
        /** @type {number} */
        this.numberOfGenerated = null
		/** @type {number} */
		this.minimumGenerationTime = null;
		/** @type {number} */
        this.averageGenerationTime = null
		/** @type {number} */
        this.maximumGenerationTime = null
	}

	/**
	 * @typedef {Object} _CaptchaGenStatTableDtoProps
	 * @property {string} profileNames
	 * @property {string} captchaTypeEngineName
	 * @property {string} captchaTypeEngineParams 
	 * @property {number} numberOfGenerated
	 * @property {number} minimumGenerationTime
	 * @property {number} averageGenerationTime
	 * @property {number} maximumGenerationTime
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _CaptchaGenStatTableDtoProps} CaptchaGenStatTableDtoProps
	 */
	/**
	 *
	 * @param {CaptchaGenStatTableDtoProps} props
	 * @returns {CaptchaGenStatTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.profileNames = props.profileNames;
		this.captchaTypeEngineName = props.captchaTypeEngineName;
		this.captchaTypeEngineParams = props.captchaTypeEngineParams;
		this.numberOfGenerated = props.numberOfGenerated;
		this.minimumGenerationTime = props.minimumGenerationTime;
		this.averageGenerationTime = props.averageGenerationTime;
		this.maximumGenerationTime = props.maximumGenerationTime;

		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}
